import { FC } from 'react';
import { Button } from '../../../../../packages/ui/components/button';
import { cn } from '@wwe-portal/ui/lib/lib';

export const LeaderboardLoadMoreButton: FC<{
  isFetchingNextPage: boolean;
  fetchNextPage: () => void;
  className?: string;
}> = ({ isFetchingNextPage, fetchNextPage, className }) => {
  return (
    <Button
      variant="secondary"
      size="large"
      loading={isFetchingNextPage}
      onClick={() => fetchNextPage()}
      className={cn(
        'bg-bgColor1 text-chetwodeBlue hover:text-inlineTextColor6 h-12 w-full px-5 text-sm font-normal',
        className
      )}
    >
      Load More
    </Button>
  );
};
